export const LOCALE_SET = "LOCALE_SET";